<template>
    <Layout>
    <PageHeader :title="title" :items="items" />
        <div>
            <household :ses_id="ses_additional.ses_id"></household>
            <div class="row">
              <div class="col-12">
              <div class="card" style="margin-bottom: 5px !important">
                <div class="card-body">
                  <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                      <label for="own_land">3.1 Do you have own land?</label>
                      <select v-model="ses_additional.own_land" id="own_land" name="own_land" class="form-control form-control-sm">
                        <option selected disabled :value="''">Select </option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
<!--            <span v-if="ses_additional.own_land === 'Yes'">-->
              <land :ses_id="ses_additional.ses_id"></land>
<!--            </span>-->
            <tree :ses_id="ses_additional.ses_id"></tree>
            <structure :ses_id="ses_additional.ses_id"></structure>
            <business :ses_id="ses_additional.ses_id"></business>
            <business-employee :ses_id="ses_additional.ses_id"></business-employee>
            <structure-rent :ses_id="ses_additional.ses_id"></structure-rent>
            <utilities-connection :ses_id="ses_additional.ses_id"></utilities-connection>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-6">
                                    <label for="land_ownership_type_id">10.1.1 Land owner:</label>
                                    <select v-model="ses_additional.land_ownership_type_id" id="land_ownership_type_id" name="land_ownership_type_id" class="form-control form-control-sm">
                                        <option selected disabled :value="''">Select</option>
                                        <option v-for="(land_ownership_type, index) in land_ownership_types" :key="index" :value="land_ownership_type.id">{{ land_ownership_type.id }} : {{ land_ownership_type.land_ownership_type_desc }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6 col-sm-6 col-lg-6">
                                    <label for="category_loss">10.1.2 Category of losses:</label>
                                    <input type="text" v-model="ses_additional.category_loss" id="category_loss" name="category_loss" class="form-control form-control-sm"/>
                                </div>
                            </div>
                            <div class="form-row mt-2">
                                <div class="col-md-6 col-sm-6 col-lg-6">
                                    <label for="alternative_land">10.1.3 Do you have any other alternative land except consumable land?</label>
                                    <select v-model="ses_additional.alternative_land" id="alternative_land" name="alternative_land" class="form-control form-control-sm">
                                        <option selected disabled :value="''">Select</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span v-if="ses_additional.alternative_land === 'Yes'">
             <land-alternative :ses_id="ses_additional.ses_id"></land-alternative>
            </span>
            <crop :ses_id="ses_additional.ses_id"></crop>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-row">
                                <div class="col-md-6 col-sm-6 col-lg-6">
                                    <label for="land_buy">11. Do you purchased any land with the cash you received in compensation?</label>
                                    <select v-model="ses_additional.land_buy" id="land_buy" name="land_buy" class="form-control form-control-sm">
                                        <option selected disabled :value="''">Select </option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span v-if="ses_additional.land_buy === 'Yes'">
            </span>
            <span v-if="ses_additional.land_buy === 'Yes'">
              <land-buy :ses_id="ses_additional.ses_id"></land-buy>
            </span>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="form-row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                      <label for="land_cultivations">12.1 Do you cultivate your damaged land yourself?</label>
                      <multiselect ref="land_cultivations" v-model="ses_additional.land_cultivations" id="land_cultivations" name="land_cultivations" :multiple="true" :clear-on-select="false" :preserve-search="true" placeholder="Select type" track-by="id" :preselect-first="true" :options="land_cultivations" :custom-label="customLandCultivation"></multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <sharecropper-land :ses_id="ses_additional.ses_id"></sharecropper-land>
            <div class="row">
                <div class="col-12">
                    <button type="submit" v-if="!this.edit" class="btn btn-success btn-sm" @click.prevent="saveAdditional()">Save</button>
                    <button type="submit" v-if="this.edit" class="btn btn-warning btn-sm float-left" @click.prevent="updateAdditional()">Update</button>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import household from "./household.vue";
    import land from "./land.vue";
    import tree from "./tree.vue";
    import structure from "./structure.vue";
    import business from "./business.vue";
    import businessEmployee from "./business-employee";
    import structureRent from "./structure-rent";
    import landAlternative from "./land-alternative";
    import landBuy from "./land-buy";
    import UtilitiesConnection from "./utilities-connection";
    import crop from "./crop";
    import sharecropperLand from "./sharecropper-land";

    import Multiselect from "vue-multiselect";

    export default {
        page: {
            title: "Fill up SES Form/step-two",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {Layout, PageHeader, Multiselect, household, land, tree, structure, business, businessEmployee, structureRent, landAlternative, landBuy, UtilitiesConnection, crop, sharecropperLand},

        data() {
            return {
                title: "SES Step Two",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Socio Economic Survey",
                        active: true,
                    }
                ],
                edit: false,
                land_ownership_types: [],
                land_cultivations: [],
                connections: [],
                ses_additional: {
                    ses_id: '',
                    own_land: '',
                    connections: [],
                    land_cultivations: [],
                    land_ownership_type_id: '',
                    category_loss: '',
                    alternative_land: '',
                    land_buy: 'No',
                },

            };
        },


        mounted() {
            this.ses_additional.ses_id = this.$route.params.ses_id;
            this.getAdditionalCodes();
            this.getAdditional(this.ses_additional.ses_id);
        },

        methods: {
            customLandCultivation(option) {
              return `${option.id} - ${option.land_cultivation_desc}`;
            },
            customConnections(option) {
                return `${option.id} - ${option.connection_desc}`;
            },
            saveAdditional() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.ses_additional.ses_id = this.$route.params.ses_id; //required
                        http
                            .post("/api/sesAdditionals", this.ses_additional)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$router.push("/ses/view/" + this.$route.params.ses_id);
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            updateAdditional() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .put("api/sesAdditionals/" + this.ses_additional.id, this.ses_additional)
                            .then(response => {
                                if (!response.data.error) {
                                    this.$router.push("/ses/view/" + this.$route.params.ses_id);
                                }
                                 this.getAdditional(this.ses_additional.ses_id);
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                            });
                    }
                });
            },
            getAdditional(ses_id) {
                http.get("api/ses/additional/" + ses_id).then(response => {
                    if (response.data.ses_additional[0] && !response.data.error) {
                        this.ses_additional = response.data.ses_additional[0];
                        this.edit = true;
                    }
                });
            },
            getAdditionalCodes() {
                http.get("api/sesAdditional/getCodes").then(response => {
                    if (!response.error) {
                        let data = response.data;
                        this.land_ownership_types = data.land_ownership_types;
                        this.connections = data.connections;
                        this.land_cultivations = data.land_cultivations;
                    }
                });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            }
        },

        created() {},

    };
</script>

<style>
    .scrollable-table {
        overflow-x: auto;
        white-space: nowrap;
    }

    .c-required{
        color: red;
    }
</style>
